import { render, staticRenderFns } from "./Resend.vue?vue&type=template&id=c5125f24"
import script from "./Resend.vue?vue&type=script&lang=js"
export * from "./Resend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports